import {EMAIL_LAYOUTS} from "./templateManifest";

export const DEFAULT_PRODUCT = {label: "JetBrains", value: "JB"};
export const ALL_PRODUCT = {value: "ALL", label: "All Products"};

export const DEFAULT_PRODUCTS_MAPPING = {
  // CoverBaker opens on the first channel a role can see, which is Social, so
  // this entry is also the product the app starts on. JetBrains Air leads.
  social: "AIR",
  livestream: "JB",
  internal: "IH",
  email: DEFAULT_PRODUCT.value,
  landingpage: DEFAULT_PRODUCT.value,
  partners: "JB",
  print: "EDU",
  video: "JB",
  events: "JB",
  // JetBrains Air: the product the channel opens on and the dropdown
  // pre-selects. It lists the Release stage alone, so the landing stage is
  // Release whatever order an admin saved.
  releases: "AIR",
  webinar: "JB",
  ads: "JB",
};

export const DEFAULT_TYPES = {
  social: {label: "General", value: "general"},
  livestream: {label: "General", value: "general"},
  internal: {label: "Workshop", value: "workshop"},
  email: {label: "General", value: "general"},
  landingpage: {label: "General", value: "general"},
  partners: {label: "General", value: "general"},
  print: {label: "General", value: "general"},
  video: {label: "General", value: "general"},
  events: {label: "General", value: "general"},
  releases: {label: "Release", value: "release"},
  webinar: {label: "If/Else", value: "if-else"},
  ads: {label: "Google Display Network", value: "google-display-network"},
};

export const options = [{label: "Social Media & Blog", value: "social"}];

// Releases channel "Set" filter — groups templates by purpose
export const RELEASES_SETS = [
  {label: "Social Media", value: "social-media", layoutIcons: ["1", "2", "3", "4", "5"]},
  {label: "Splash", value: "splash", layoutIcons: ["1"]},
  {label: "What's New Preview", value: "whats-new", layoutIcons: ["1", "2"]},
  // The Email channel's banners (EMAIL_MEMBERSHIPS in templateManifest.ts), on
  // that channel's layouts and with its layout icons.
  {
    label: "Emails",
    value: "emails",
    layoutIcons: EMAIL_LAYOUTS.map(String),
    layoutIconChannel: "email",
  },
  {label: "Webpage Preview", value: "webpreview", layoutIcons: ["1"]},
  {label: "Wallpapers", value: "wallpapers", layoutIcons: ["1"]},
  {
    label: "Screenshots",
    value: "screenshots",
    layoutIcons: ["20", "21", "22", "23", "24", "25", "26", "27"],
  },
  // The 1920x1080 frames of release demo videos (Figma "YouTube", section
  // "CoverBaker / HANDOFF / IntelliJ IDEA"): intro, intro with a screenshot,
  // a screenshot on the product artwork, and code with a highlight.
  {label: "Demo Video", value: "demo-video", layoutIcons: ["1"]},
];

// The channel-wide default. Products can offer a subset of RELEASES_SETS, so
// read the per-product list through `releasesSetsForProduct` /
// `defaultReleasesSetForProduct` (src/data/products/index.js) rather than
// assuming this one — it is the first set only for a product that offers all.
export const DEFAULT_RELEASES_SET = RELEASES_SETS[0]; // Social Media

// Max upload size enforced client-side before a file is sent. Kept in sync
// with the nginx ingress `proxy-body-size` (deploy/templates/ingress.yaml.j2)
// and the server-side cap in src/server/api/v3/uploads.ts — all three are 50 MB.
export const UPLOAD_MAX_BYTES = 50 * 1024 * 1024; // 50 MB

export const KRAKEN_URL = "https://d3r50642m20jlp.cloudfront.net/kraken/tiles";
export const THUMBNAILS_URL = "https://d3r50642m20jlp.cloudfront.net/kraken/gdrive_thumbnails";

export const MANUAL_LINK = "https://youtrack.jetbrains.com/articles/DSGN-A-55/CoverBaker";
export const MANUAL_LINK_PARTNERS =
  "https://resources.jetbrains.com/cai/coverbaker/CoverBaker_Partner_Guide.pdf";
export const FEEDBACK_LINK = "https://jetbrains.slack.com/archives/C07JLAY1MFB";
export const FEEDBACK_LINK_PARTNERS = "mailto:resellers@jetbrains.com";
export const PREPARE_PHOTO_LINK = "https://slack.com/app_redirect?app=A056WC694N6";

// Example data link used in DataSelector
export const EXAMPLE_DATA_LINK =
  "https://docs.google.com/spreadsheets/d/1b1VP-82GDdMEtkZdR5t4f-miT-bycVpWN58IsMlcke0/edit?gid=0#gid=0";

export const NEUROBAKER = `${KRAKEN_URL}/Neurobaker`;

export const UPLOAD_ICON_URL = `${NEUROBAKER}/UI/upload.svg`;

export const EYE_FALSE = `${NEUROBAKER}/UI/Icons/eye-false.svg`;
export const EYE_TRUE = `${NEUROBAKER}/UI/Icons/eye-true.svg`;
export const IMG = `${NEUROBAKER}/UI/Icons/bg.svg`;
export const PORTRAIT = `${NEUROBAKER}/UI/Icons/img.svg`;
export const SCREENSHOT = `${NEUROBAKER}/UI/Icons/screenshot.svg`;
export const ZOOMIN = `${NEUROBAKER}/UI/Icons/plus.svg`;
export const ZOOMOUT = `${NEUROBAKER}/UI/Icons/minus.svg`;
export const RESET = `${NEUROBAKER}/UI/Icons/reset.svg`;
export const TRASH_BIN = `${NEUROBAKER}/UI/Icons/trash-bin.svg`;
export const ROTATE_L = `${NEUROBAKER}/UI/Icons/rotate-left.svg`;
export const ROTATE_R = `${NEUROBAKER}/UI/Icons/rotate-right.svg`;
export const FLIP_V = `${NEUROBAKER}/UI/Icons/flip-vertical.svg`;
export const FLIP_H = `${NEUROBAKER}/UI/Icons/flip-horizontal.svg`;

export const LOCK_FALSE = `${NEUROBAKER}/UI/Icons/sync.svg`;
export const LOCK_TRUE = `${NEUROBAKER}/UI/Icons/unsync.svg`;
export const DOWNLOAD_ICON_URL = `${NEUROBAKER}/UI/download.svg`;
export const VIDEO = `${NEUROBAKER}/UI/Icons/video.svg`;
export const GIF = `${NEUROBAKER}/UI/Icons/gif.svg`;

export const GENERAL_BG = `${NEUROBAKER}/Backgrounds/social/general/1`;
export const BACKGROUNDS = `${NEUROBAKER}/Backgrounds`;

export const UI = `${NEUROBAKER}/UI`;
export const logoIconWhite = `${NEUROBAKER}/Logos/JETBRAINS_white_icon_white.svg`;
export const logoNorm = `${NEUROBAKER}/Logos/JETBRAINS_logo_white.svg`;
export const logoNormInverted = `${NEUROBAKER}/Logos/JETBRAINS_logo_white_inverted.svg`;
export const logoWhite = `${NEUROBAKER}/Logos/JETBRAINS_white_logo_white.svg`;
export const logoIDE = `${NEUROBAKER}/Logos/JETBRAINS_IDEs_logo_white.svg`;
export const logoNormBlack = `${NEUROBAKER}/Logos/JETBRAINS_logo_black.svg`;
export const logoNormBlackInverted = `${NEUROBAKER}/Logos/JETBRAINS_logo_black_inverted.svg`;
export const logoIDEBlack = `${NEUROBAKER}/Logos/JETBRAINS_IDEs_logo_black.svg`;
export const logoNormBlackOutlined = `${NEUROBAKER}/Logos/JETBRAINS_black_logo_white_outlined.svg`;
export const logoIDEBlackOutlined = `${NEUROBAKER}/Logos/JETBRAINS_IDEs_black_logo_white_outlined.svg`;
export const logoIDEBlackInverted = `${NEUROBAKER}/Logos/JETBRAINS_IDEs_black_logo_white.svg`;
export const logoIDEWhite = `${NEUROBAKER}/Logos/JETBRAINS_IDEs_white_logo_white.svg`;
export const logoWhiteHole = `${NEUROBAKER}/Logos/JETBRAINS_white_logo_white_hole.svg`;
export const logoIDEWhiteHole = `${NEUROBAKER}/Logos/JETBRAINS_IDEs_white_logo_white_hole.svg`;
export const logoAcademyNorm = `${NEUROBAKER}/Logos/JetBrains_Academy_logo_white.svg`;
export const logoAcademyBlack = `${NEUROBAKER}/Logos/JetBrains_Academy_logo_black.svg`;
export const logoAcademyBlackInverted = `${NEUROBAKER}/Logos/JetBrains_Academy_logo_black_inverted.svg`;
export const logoGameDevNorm = `${NEUROBAKER}/Logos/JetBrains_GameDev_logo_white.svg`;
export const logoGameDevBlack = `${NEUROBAKER}/Logos/JetBrains_GameDev_logo_black.svg`;
export const logoMarketplaceNorm = `${NEUROBAKER}/Logos/JetBrains_Marketplace_logo_white.svg`;
export const logoMarketplaceBlack = `${NEUROBAKER}/Logos/JetBrains_Marketplace_logo_black.svg`;
export const logoDotNETNorm = `${NEUROBAKER}/Logos/JetBrains_dotNET_logo_white.svg`;
export const logoDataNorm = `${NEUROBAKER}/Logos/JetBrains_Data_logo_white.svg`;
export const logoDataBlack = `${NEUROBAKER}/Logos/JetBrains_Data_logo_black.svg`;
export const logoDataWhite = `${NEUROBAKER}/Logos/JetBrains_Data_logo_white_inverted.svg`;
export const logoDotNETBlack = `${NEUROBAKER}/Logos/JetBrains_dotNET_logo_black.svg`;
export const logoAINorm = `${NEUROBAKER}/Logos/JETBRAINS_AI_logo_white.svg`;
export const logoAIBlack = `${NEUROBAKER}/Logos/JETBRAINS_AI_logo_black.svg`;
export const logoMinimal = `${NEUROBAKER}/Logos/JetBrains_logo_minimal.svg`;
export const logoMinimalColor = `${NEUROBAKER}/Logos/JETBRAINS_icon.svg`;
export const logoYouTrackBlack = `${NEUROBAKER}/Logos/YouTrack_logo_black.svg`;
export const logoHyperskill = `${NEUROBAKER}/Logos/hyperskill.svg`;
export const logoJN = `${NEUROBAKER}/Logos/Junie_logo_white.svg`;
export const logoKT = `${NEUROBAKER}/Logos/KT.svg`;
export const logoKM = `${NEUROBAKER}/Logos/KM.svg`;
export const logoKTR = `${NEUROBAKER}/Logos/KTR_logo_white.svg`;
export const logoEXP = `${NEUROBAKER}/Logos/EXP.svg`;
export const logoWhiteTransparent = `${NEUROBAKER}/Logos/JetBrains_white_transparent.svg`;
export const logoBlackMinimal = `${NEUROBAKER}/Logos/JETBRAINS _black_logo_minimal.svg`;

export const logoJNBlack = `${NEUROBAKER}/Logos/Junie_logo_black.svg`;
export const logoDatabaoOutlined = `${NEUROBAKER}/Logos/JETBRAINS_logo_white_outlined.svg`;
export const logoFoundationWhite = `${NEUROBAKER}/Logos/JetBrains_Foundation_logo_white.svg`;
export const logoFoundationBlack = `${NEUROBAKER}/Logos/JetBrains_Foundation_logo_black.svg`;
export const logoFoundationWhiteInverted = `${NEUROBAKER}/Logos/JetBrains_Foundation_logo_white_inverted.svg`;
export const logoFoundationBlackInverted = `${NEUROBAKER}/Logos/JetBrains_Foundation_logo_black_inverted.svg`;
export const logoFoundationBlackInvertedOutline = `${NEUROBAKER}/Logos/JetBrains_Foundation_logo_black_inverted_outline.svg`;
export const logoFoundationWhiteTwo = `${NEUROBAKER}/Logos/JetBrains_Foundation_logo_white_two.svg`;
export const logoFoundationBlackTwo = `${NEUROBAKER}/Logos/JetBrains_Foundation_logo_black_two.svg`;
export const logoFoundationWhiteInvertedTwo = `${NEUROBAKER}/Logos/JetBrains_Foundation_logo_white_inverted_two.svg`;
export const logoFoundationBlackInvertedTwo = `${NEUROBAKER}/Logos/JetBrains_Foundation_logo_black_inverted_two.svg`;

export const PRODUCT_LOGO_CYCLES = {
  _default: [
    null,
    logoNorm,
    logoNormBlack,
    logoNormBlackOutlined,
    logoNormBlackInverted,
    logoNormInverted,
    logoWhite,
    logoWhiteHole,
  ],
  _ide: [
    null,
    logoIDE,
    logoIDEBlack,
    logoIDEBlackOutlined,
    logoIDEBlackInverted,
    logoIDEWhite,
    logoIDEWhiteHole,
    logoNorm,
    logoNormBlack,
    logoNormBlackOutlined,
    logoNormBlackInverted,
    logoWhite,
    logoWhiteHole,
  ],
  EDU: [null, logoAcademyNorm, logoAcademyBlack, logoNorm, logoNormBlack],
  UNI: [
    null,
    logoNorm,
    logoNormBlack,
    logoNormBlackInverted,
    logoNormInverted,
    logoWhite,
    logoWhiteHole,
    logoAcademyNorm,
    logoAcademyBlack,
    logoAcademyBlackInverted,
    logoFoundationWhite,
    logoFoundationBlack,
    logoFoundationWhiteInverted,
    logoFoundationBlackInverted,
    logoFoundationBlackInvertedOutline,
    logoFoundationWhiteTwo,
    logoFoundationBlackTwo,
    logoFoundationWhiteInvertedTwo,
    logoFoundationBlackInvertedTwo,
  ],
  DN: [null, logoDotNETNorm, logoDotNETBlack, logoNorm, logoNormBlack],
  AI: [null, logoAINorm, logoAIBlack, logoNorm, logoNormBlack],
  GDV: [null, logoGameDevNorm, logoGameDevBlack, logoNorm, logoNormBlack],
  MP: [null, logoMarketplaceNorm, logoMarketplaceBlack, logoNorm, logoNormBlack],
  YT: [null, logoNorm, logoNormBlack, logoYouTrackBlack],
  DG: [
    null,
    logoDataNorm,
    logoDataBlack,
    logoDataWhite,
    logoNorm,
    logoNormBlack,
    logoWhite,
    logoWhiteHole,
  ],
  DL: [null, logoDataNorm, logoDataBlack, logoDataWhite, logoNorm, logoNormBlack],
  PCD: [null, logoDataNorm, logoDataBlack, logoDataWhite, logoNorm, logoNormBlack],
  JBD: [null, logoDataNorm, logoDataBlack, logoDataWhite, logoNorm, logoNormBlack],
  DBAO: [null, logoDatabaoOutlined, logoNorm, logoNormBlack],
  JN: [null, logoJN, logoJNBlack],
  IH: [null, logoNormBlack, logoNormInverted, logoNorm],
  AS: [null, logoNorm, logoNormInverted, logoNormBlack],
};

export const newsletterLayoutTypes = ["java-annotated", "php-annotated", "newsletter"];
export const CONTENT_TYPES_WITHOUT_LAYOUTS = [...newsletterLayoutTypes, "new"];
export const CHANNELS_WITHOUT_LAYOUTS = ["print"];

export const fontSizes = [
  {label: "-2", value: 0.8},
  {label: "-1", value: 0.9},
  {label: "standard font size", value: 1},
  {label: "+1", value: 1.1},
  {label: "+2", value: 1.2},
  // {label: "giant", value: 2},
];

export const ICONS = ["key", "book", "diamond", "java", "track", "lamp"];

export const TEXT_CLASSNAMES = [
  "title",
  "subtitle",
  "subtitle2",
  "subtitle3",
  "name",
  "name2",
  "name3",
  "name4",
  "name5",
  "name6",
  "badge",
  "gdn-button",
  "position",
  "position2",
  "date",
  "time",
  "eap",
  "link",
  "link2",
  "link3",
  "editabletag",
  "gdn-tag",
  "features",
  "version",
  "product-name",
];

export const GRID_CONFIG = {
  Twitter: 75,
  YouTubeCommunity: 60,
  SoMeVertical: 60,
  InstagramStories: 120,
  InstagramFeed: 90,
  BlogFeatured: 80,
  BlogSocialShare: 80,
  // GDN exports at 2x. These values preserve the grid density of the closest
  // Social canvas for each aspect ratio.
  InlineRectangleAds: 30,
  LargeRectangleAds: 40,
  BillboardAds: 120,
  HalfPageAds: 75,
  WideSkyscraperAds: 75,
  Leaderboard970Ads: 120,
  Leaderboard728Ads: 90,
  Leaderboard468Ads: 60,
  GdnJapanAds: 40,
  GdnResponsive1200x628Ads: 75,
  GdnResponsive1200x1200Ads: 60,
  Email01: 65,
  Email02: 65,
  Email03: 65,
  Email04: 65,
  HorizontalFeatures: 75,
  Wallpaper1: 80,
  Wallpaper2: 80,
  Wallpaper3: 80,
  WallpaperPreview: 40,
  WebpagePreview: 80,
  Splash: 20,
  Splash2x: 40,
  Splash2026: 20,
  Splash2x2026: 40,
  WhatsNewPreview: 80,
  LandingPage: 80,
};

export const PLACEHOLDERS = {
  en: {
    title: "Write your own text here",
    title_JB_ai: "Have your say\nand win a\nMacBook Pro!",
    subtitle_JB_ai: "Will AI replace\ndevelopers?",
    title_JB_deveco: "Win a\nMacBook Pro!",
    subtitle_JB_deveco: "Developer Ecosystem \nSurvey 2026",
    title_JB_newsletter: "JetBrains\nNewsletter",
    title_DN_newsletter: "dotInsights\n.NET\nNewsletter",
    title_TC_newsletter: "TeamCity\nPipelines\nPulse",
    title_PS_newsletter: "PHP\nAnnotated",
    title_IJ_newsletter: "Java\nAnnotated\nMonthly",
    title_MP_newsletter: "Busy Plugin\nDevelopers\nNewsletter",
    date: "Date",
    time: "Time",
    date_JB_newsletter: "Issue #",
    date_DN_newsletter: "Issue #",
    date_TC_newsletter: "Issue #",
    date_PS_newsletter: "Issue #",
    date_IJ_newsletter: "Issue #",
    date_MP_newsletter: "Q1 2025",
    subtitle: "And here write something else",
    subtitle2: "And here write something else",
    subtitle3: "And here write something else",
    position: "Position",
    position2: "Job title",
    episode: "Links",
    secondLine: "Links",
    thirdLine: "Links",
    name: "Host name",
    name2: "Host 2 name",
    name3: "Host 3 name",
    name4: "Host 4 name",
    name5: "Host 5 name",
    name6: "Host 6 name",
    link: "jb.gg/shortlink",
    link2: "jb.gg/shortlink",
    link3: "jb.gg/shortlink",
    emailName: "Write the name here",
    livestream: "Livestream",
    button: "Button text",
    eap: "202X.X EAP",
    version: "2026.3",
    discount: "JetBrainsStudentTechQuizvol4yhzKXcxr",
    voucher_date: "Redeem before March 31, 2025",
    voucher_title: "1-Year Personal Subscription",
    voucher_subtitle: "100% Discount Code",
    voucher_link: "jb.gg/academy/quiz",
    features: "• Feature 1\n• Feature 2\n• Feature 3",
    thumbnails: `<span class='highlight'>Ran Out of</span><br><span class='highlight'>Licenses Again?</span><br><span class='highlight color'>Watch This</span>`,
  },
  de: {
    title: "Schreiben Sie Ihren Text",
    date: "Datum",
    time: "Zeit",
    subtitle: "Und hier schreiben Sie etwas anderes",
    subtitle2: "Und hier schreiben Sie etwas anderes",
    subtitle3: "Und hier schreiben Sie etwas anderes",
    position: "Position",
    episode: "Links",
    secondLine: "Links",
    thirdLine: "Links",
    livestream: "Livestream",
    button: "Button text",
    name: "Host name",
    link: "jb.gg/shortlink",
    link2: "jb.gg/shortlink",
    link3: "jb.gg/shortlink",
    emailName: "Write the name here",
    eap: "202X.X EAP",
    version: "2026.3",
    discount: "JetBrainsStudentTechQuizvol4yhzKXcxr",
    voucher_date: "Redeem before March 31, 2025",
    thumbnails: `<span class='highlight'>Ran Out of</span><br><span class='highlight'>Licenses Again?</span><br><span class='highlight color'>Watch This</span>`,
  },
  fr: {
    title: "Écrivez votre texte",
    date: "Date",
    time: "Time",
    subtitle: "Et ici écrivez quelque chose d'autre",
    subtitle2: "Et ici écrivez quelque chose d'autre",
    subtitle3: "Et ici écrivez quelque chose d'autre",
    position: "Position",
    episode: "Liens",
    secondLine: "Liens",
    thirdLine: "Liens",
    livestream: "Livestream",
    button: "Button text",
    name: "Host name",
    link: "jb.gg/shortlink",
    link2: "jb.gg/shortlink",
    link3: "jb.gg/shortlink",
    emailName: "Write the name here",
    eap: "202X.X EAP",
    version: "2026.3",
    discount: "JetBrainsStudentTechQuizvol4yhzKXcxr",
    voucher_date: "Redeem before March 31, 2025",
    thumbnails: `<span class='highlight'>Ran Out of</span><br><span class='highlight'>Licenses Again?</span><br><span class='highlight color'>Watch This</span>`,
  },
  es: {
    title: "Escriba su texto",
    date: "Fecha",
    time: "Hora",
    subtitle: "Y aquí escribe algo más",
    subtitle2: "Y aquí escribe algo más",
    subtitle3: "Y aquí escribe algo más",
    position: "Posición",
    episode: "Enlaces",
    secondLine: "Enlaces",
    thirdLine: "Enlaces",
    livestream: "Livestream",
    button: "Button text",
    name: "Host name",
    link: "jb.gg/shortlink",
    link2: "jb.gg/shortlink",
    link3: "jb.gg/shortlink",
    emailName: "Write the name here",
    eap: "202X.X EAP",
    version: "2026.3",
    discount: "JetBrainsStudentTechQuizvol4yhzKXcxr",
    voucher_date: "Redeem before March 31, 2025",
    thumbnails: `<span class='highlight'>Ran Out of</span><br><span class='highlight'>Licenses Again?</span><br><span class='highlight color'>Watch This</span>`,
  },
  br: {
    title: "Escreva seu texto aqui",
    date: "Data",
    time: "Hora",
    subtitle: "E aqui escreva algo mais",
    subtitle2: "E aqui escreva algo mais",
    subtitle3: "E aqui escreva algo mais",
    position: "Posição",
    episode: "Links",
    secondLine: "Links",
    thirdLine: "Links",
    livestream: "Livestream",
    button: "Button text",
    name: "Host name",
    link: "jb.gg/shortlink",
    link2: "jb.gg/shortlink",
    link3: "jb.gg/shortlink",
    emailName: "Write the name here",
    eap: "202X.X EAP",
    version: "2026.3",
    discount: "JetBrainsStudentTechQuizvol4yhzKXcxr",
    voucher_date: "Redeem before March 31, 2025",
    thumbnails: `<span class='highlight'>Ran Out of</span><br><span class='highlight'>Licenses Again?</span><br><span class='highlight color'>Watch This</span>`,
  },
  jp: {
    title: "テキストを書いて。",
    date: "日付",
    time: "時刻",
    subtitle: "そしてここに何か他のことを書いてください",
    subtitle2: "そしてここに何か他のことを書いてください",
    subtitle3: "そしてここに何か他のことを書いてください",
    position: "位置",
    episode: "リンク",
    secondLine: "リンク",
    thirdLine: "リンク",
    livestream: "Livestream",
    button: "Button text",
    name: "Host name",
    link: "jb.gg/shortlink",
    link2: "jb.gg/shortlink",
    link3: "jb.gg/shortlink",
    emailName: "Write the name here",
    eap: "202X.X EAP",
    version: "2026.3",
    discount: "JetBrainsStudentTechQuizvol4yhzKXcxr",
    voucher_date: "Redeem before March 31, 2025",
    thumbnails: `<span class='highlight'>Ran Out of</span><br><span class='highlight'>Licenses Again?</span><br><span class='highlight color'>Watch This</span>`,
  },
  ch: {
    title: "在这里写下你自己的文本",
    date: "日期",
    time: "时间",
    subtitle: "然后在这里写点别的",
    subtitle2: "然后在这里写点别的",
    subtitle3: "然后在这里写点别的",
    position: "职位",
    episode: "链接",
    secondLine: "链接",
    thirdLine: "链接",
    livestream: "Livestream",
    button: "Button text",
    name: "Host name",
    link: "jb.gg/shortlink",
    link2: "jb.gg/shortlink",
    link3: "jb.gg/shortlink",
    emailName: "Write the name here",
    eap: "202X.X EAP",
    version: "2026.3",
    discount: "JetBrainsStudentTechQuizvol4yhzKXcxr",
    voucher_date: "Redeem before March 31, 2025",
    thumbnails: `<span class='highlight'>Ran Out of</span><br><span class='highlight'>Licenses Again?</span><br><span class='highlight color'>Watch This</span>`,
  },
  kr: {
    title: "텍스트를 작성하세요",
    date: "날짜",
    time: "시간",
    subtitle: "그리고 여기에 다른 것을 쓰세요",
    subtitle2: "그리고 여기에 다른 것을 쓰세요",
    subtitle3: "그리고 여기에 다른 것을 쓰세요",
    position: "직위",
    episode: "링크",
    secondLine: "링크",
    thirdLine: "링크",
    livestream: "Livestream",
    button: "Button text",
    name: "Host name",
    link: "jb.gg/shortlink",
    link2: "jb.gg/shortlink",
    link3: "jb.gg/shortlink",
    emailName: "Write the name here",
    eap: "202X.X EAP",
    version: "2026.3",
    discount: "JetBrainsStudentTechQuizvol4yhzKXcxr",
    voucher_date: "Redeem before March 31, 2025",
    thumbnails: `<span class='highlight'>Ran Out of</span><br><span class='highlight'>Licenses Again?</span><br><span class='highlight color'>Watch This</span>`,
  },
  tr: {
    title: "Kendi metnini buraya yaz",
    date: "Tarih",
    time: "Saat",
    subtitle: "Ve buraya başka bir şey yaz",
    subtitle2: "Ve buraya başka bir şey yaz",
    subtitle3: "Ve buraya başka bir şey yaz",
    position: "Pozisyon",
    episode: "Bağlantılar",
    secondLine: "Bağlantılar",
    thirdLine: "Bağlantılar",
    livestream: "Livestream",
    button: "Button text",
    name: "Host name",
    link: "jb.gg/shortlink",
    link2: "jb.gg/shortlink",
    link3: "jb.gg/shortlink",
    emailName: "Write the name here",
    eap: "202X.X EAP",
    version: "2026.3",
    discount: "JetBrainsStudentTechQuizvol4yhzKXcxr",
    voucher_date: "Redeem before March 31, 2025",
    thumbnails: `<span class='highlight'>Ran Out of</span><br><span class='highlight'>Licenses Again?</span><br><span class='highlight color'>Watch This</span>`,
  },
  ru: {
    title: "Напишите текст",
    date: "Дата",
    time: "Время",
    subtitle: "И здесь напишите что-нибудь ещё",
    subtitle2: "И здесь напишите что-нибудь ещё",
    subtitle3: "И здесь напишите что-нибудь ещё",
    position: "Позиция",
    episode: "Ссылки",
    secondLine: "Ссылки",
    thirdLine: "Ссылки",
    livestream: "Livestream",
    button: "Надпись на кнопке",
    name: "Имя хоста",
    link: "jb.gg/shortlink",
    link2: "jb.gg/shortlink",
    link3: "jb.gg/shortlink",
    emailName: "Write the name here",
    eap: "202X.X EAP",
    version: "2026.3",
    discount: "JetBrainsStudentTechQuizvol4yhzKXcxr",
    voucher_date: "Redeem before March 31, 2025",
    thumbnails: `<span class='highlight'>Ran Out of</span><br><span class='highlight'>Licenses Again?</span><br><span class='highlight color'>Watch This</span>`,
  },
};
